import React from 'react';
import clsx from 'clsx';
import {
    CancelButton,
    NameTextField,
    ConfirmButton
} from '../../../../../../styling/Styles';
import {
    checkIfEmpty,
    checkDublicateBlockName,
    checkHasSpaces
} from "../../../../../../validations/validations"
import extractContent from './ExtractContent';

const GenerateFormBlock = (props) => {

    const{
        producedBlockName,
        setProducedBlockName,
        setClickedButtonGenerate,
        editor,
        selectedProject,
        dataElementName,
        componentsInfo,
        setOpenSnackBar,
        setOpenAlert,
        setClickedEdit
    }= props;

    //  This function changes the name of the data element that belongs the edited form.At this point it is disabled
    const handleBlockName = (e) => {
        setProducedBlockName(e.target.value);
    }

    /*
    This functions is connected with the 'Cancel' button of the pop up window that we give the name of the new block and when is clicked
    the edit form window is displayed 
    */
    const deactivateGenerateButton = () => {
        setClickedButtonGenerate(false);
    }

    /*
    This functions generates a new block based on the changes that we made on edited form, it closes the edit form pop up window and 
    then it displays a snackbar message
    */
    const generateBlock = () => {

        if( checkIfEmpty(producedBlockName) === false && checkDublicateBlockName(producedBlockName, editor) === false && checkHasSpaces() === false){
             extractContent(editor,
                 selectedProject,
                 dataElementName,
                 producedBlockName,
                 componentsInfo);
             setOpenSnackBar(true);
             setClickedButtonGenerate(false);
             setOpenAlert(false);
             setClickedEdit(false);
        }
        
     }

    return(
        <div>
            <div className={clsx('titlePopUp','paddingTitle')}> Generate block</div>
            <div className ='paddingTitle'>
                <div className={clsx('flexRowDirection')}>
                    <span>Block name: &nbsp;</span>
                    <NameTextField
                        id='DataBlockName'
                        placeholder='block name'
                        error={checkIfEmpty(producedBlockName) === true|| checkDublicateBlockName(producedBlockName, editor) === true || checkHasSpaces() === true}
                        helperText = {
                            checkIfEmpty(producedBlockName) === true ? 'Block name is empty' :
                            (
                                checkDublicateBlockName(producedBlockName,editor) === true && 'Block name exists'
                            )
                        }
                        value={producedBlockName}
                        onInput={e => handleBlockName(e)}
                    />
                </div>
                <div className={clsx('flex-container', 'spacingDownDiv')} 
                    style={{
                        justifyContent:'space-between',
                        display: 'flex',
                        flexDirection: 'row', 
                        marginTop: '1vw',
                        minWidth: '20vw'
                    }}

                >
                    <div >
                        <CancelButton onClick={deactivateGenerateButton}>
                            Cancel
                        </CancelButton >
                    </div>
                    <div className={clsx('flexRowDirection')}>
                        <ConfirmButton
                        onClick={generateBlock}
                        >
                            Generate 
                        </ConfirmButton>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default GenerateFormBlock;